export default __webpack_public_path__ + "static/media/inr-flag.baaff04e.svg";